export default "__VITE_ASSET__B3gh5tSc__"